import { format } from "date-fns";

export type ApiDateTimeInput = string | Date | null | undefined;

const hasTimezone = (value: string) =>
  /[zZ]$/.test(value) || /[+-]\d{2}:?\d{2}$/.test(value);

export const parseApiDateTime = (value: string): Date | null => {
  const trimmed = value.trim();
  if (!trimmed) return null;

  const normalized =
    !hasTimezone(trimmed) && trimmed.includes("T") ? `${trimmed}Z` : trimmed;

  const date = new Date(normalized);
  return Number.isNaN(date.getTime()) ? null : date;
};

const toDate = (value: ApiDateTimeInput): Date | null => {
  if (!value) return null;
  if (value instanceof Date) {
    return Number.isNaN(value.getTime()) ? null : value;
  }
  return parseApiDateTime(value);
};

export const formatApiDateTime = (
  value: ApiDateTimeInput,
  pattern = "DD/MM/YY HH:mm",
): string => {
  const date = toDate(value);
  if (!date) return "";
  return format(date, pattern);
};

export const getApiDateTimeMs = (value: ApiDateTimeInput): number => {
  const date = toDate(value);
  return date ? date.getTime() : 0;
};
